var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#006A70","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"M20.2385 10h3.9996c.4762 0 .7619.3809.7619.7619V27.238c0 .4762-.3809.762-.7619.762H7.7619C7.2857 28 7 27.619 7 27.238V10.7619c0-.4762.381-.7619.7619-.7619h3.9051m9.833 6L16 22m0 0-5.5-6m5.5 6V3"}));
}

Upload.defaultProps = {"width":"32","height":"32","fill":"none","viewBox":"0 0 32 32"};

module.exports = Upload;

Upload.default = Upload;
